import React, { useState } from 'react';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import HomeWriterEntry from '@/components/home/HomeWriterEntry';
import HomeProductProof from '@/components/home/HomeProductProof';
import CommunitySection from '@/components/home/CommunitySection';
import HomeClosingChoice from '@/components/home/HomeClosingChoice';
import ConnectionStatus from '@/components/home/ConnectionStatus';
import IndexPageSEO from '@/components/home/IndexPageSEO';
import { useHomepagePapers } from '@/hooks/useHomepagePapers';
import { useIndexPageState } from '@/hooks/useIndexPageState';

const Index = () => {
  const { connectionStatus } = useIndexPageState();
  const { featured, recent, isLoading } = useHomepagePapers(3);
  const [composerActive, setComposerActive] = useState(false);

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <IndexPageSEO />
      <Navbar />
      <main className="flex-1">
        <HomeWriterEntry onActiveChange={setComposerActive} />
        <ConnectionStatus connectionStatus={connectionStatus} />
        <HomeProductProof paused={composerActive} />
        <CommunitySection featuredPaper={featured} papers={recent} isLoading={isLoading} />
        <HomeClosingChoice />
      </main>
      <Footer noMarginTop />
    </div>
  );
};

export default Index;
